import { Exclude, Expose } from 'class-transformer';

@Exclude()
export class UserLoginResponseModel {
  public token: string;

  public refresh_token: string;
}
